// libs.
import Spinner from 'react-bootstrap/Spinner';
import { Col, Row } from 'react-bootstrap';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// hooks.
import { useDocumentsHistory } from '../../hooks/useDocumentsHistory';
import { InProgressStepsCards } from '@domains/orchestrator-pricing-committee';

// components.
import { DocumentsHistoryList } from '../DocumentsHistoryList/DocumentsHistoryList';

// selectors.
import { getSelectedTask } from '../../store/slices/document-review-slice';
import { setSelectedAlias } from '@domains/orchestrator-pricing-committee/store/slices/domainOrchestratorPricingCommittee.slice';

export const DocumentsHistoryLayout = () => {
  const dispatch = useDispatch();
  const selectedTask = useSelector(getSelectedTask);
  const { data: history = [], isLoading, nid } = useDocumentsHistory();

  useEffect(() => {
    if (selectedTask?.business_type) {
      const businessType = selectedTask.business_type.toLowerCase();

      if (businessType === 'real_estate') {
        dispatch(setSelectedAlias('inmo'));
      } else {
        dispatch(setSelectedAlias('market-maker'));
      }
    }
  }, [selectedTask?.business_type, dispatch]);

  if (isLoading) {
    return (
      <div
        className="d-flex justify-content-center p-4"
        data-testid="history-loading"
      >
        <Spinner animation="border" variant="secondary" />
        <span className="ms-2">Validando si hay Revisiones Previas...</span>
      </div>
    );
  }

  if (history.length <= 1) {
    return null;
  }

  return (
    <Row
      className="p-3"
      data-testid="history-layout"
      style={{ maxHeight: 'calc(100vh - 222px)', overflowY: 'auto' }}
    >
      <Col lg={8}>
        <DocumentsHistoryList />
      </Col>
      <Col lg={4}>{nid ? <InProgressStepsCards nid={nid} /> : null}</Col>
    </Row>
  );
};
